import React from 'react'

const NotificationsIcon = () => {
  return (
    <svg
      width='37'
      height='36'
      viewBox='0 0 37 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#c9dgncwv1a)'>
        <path fill='#fff' d='M-539-22H61v983h-600z' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-539-22H61v1745h-600V-22z'
          fill='#EEF1F5'
        />
        <g clipPath='url(#cte119wz4b)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M61-22h-600v80H61v-80z'
            fill='#fff'
          />
          <circle cx='19' cy='18' r='18' stroke='#E6EBF1' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M19.847 9a.847.847 0 1 0-1.694 0v1.108c-3.658.422-6.495 3.54-6.495 7.32v5.676H10a.847.847 0 0 0 0 1.694h5.208A3.888 3.888 0 0 0 19 27.848a3.888 3.888 0 0 0 3.792-3.05H28a.847.847 0 1 0 0-1.694h-1.658v-5.676c0-3.78-2.836-6.898-6.495-7.32V9zm1.175 15.798A2.19 2.19 0 0 1 19 26.153a2.191 2.191 0 0 1-2.022-1.355h4.044zm1.015-1.694h2.61v-5.676c0-3.132-2.522-5.666-5.63-5.674h-.033c-3.108.008-5.632 2.542-5.632 5.674v5.676h8.685z'
            fill='#1F2532'
          />
        </g>
      </g>
      <defs>
        <clipPath id='c9dgncwv1a'>
          <path
            fill='#fff'
            transform='translate(-539 -22)'
            d='M0 0h600v983H0z'
          />
        </clipPath>
        <clipPath id='cte119wz4b'>
          <path
            fill='#fff'
            transform='translate(-539 -22)'
            d='M0 0h600v80H0z'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default NotificationsIcon
